"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeartButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _heart = _interopRequireDefault(require("../../../assets/svg/heart.svg"));
var _heartFilled = _interopRequireDefault(require("../../../assets/svg/heart-filled.svg"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HeartButton = _styledComponents.default.svg.attrs(function (_ref) {
  var type = _ref.type;
  return {
    type: type || 'button'
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: none;\n  background-image: url(", ");\n  background-size: 50%;\n  background-repeat: no-repeat;\n  background-color: #8b35c9;\n  background-position: center;\n  border-radius: 100%;\n  color: #ffc033;\n  width: 39px;\n  height: 39px;\n  ", "\n  -webkit-appearance: none;\n\n  &:active,\n  :focus {\n    outline: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n"])), function (_ref2) {
  var liked = _ref2.liked;
  return liked ? _heartFilled.default : _heart.default;
}, function (_ref3) {
  var $bsStyle = _ref3.$bsStyle;
  return $bsStyle || '';
});
exports.HeartButton = HeartButton;